import { c as _c } from "react/compiler-runtime";
import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { AppInstallConfirmModal } from './_components/AppInstallConfirmModal';
import { LocationServiceConsentDrawer } from './_components/LocationServiceConsentDrawer';
import { LoginRedirectionConfirmModal } from './_components/LoginRedirectionConfirmModal';
import { RegionDrawer } from './_components/RegionDrawer';
import { TermsDrawer } from './_components/TermsDrawer';
import { WelloWebLinkModal } from './_components/WelloWebLinkModal';
export const GlobalModal = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ErrorBoundary fallback={null}><Suspense><TermsDrawer /><WelloWebLinkModal /><RegionDrawer /><LocationServiceConsentDrawer /><LoginRedirectionConfirmModal /><AppInstallConfirmModal /></Suspense></ErrorBoundary>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};